export default {
	SET_FREQUENCY (state, val) {
		if (Array.isArray(val)) {
			state.frequency = val
		} else {
			state.frequency = []
		}
	},
	SET_LOADING (state, val) {
		state.loading = val
	}
}
